<!-- Innovadis custom: added class name to be able to style conditionally -->
<!-- Innovadis custom: formatting-->
<template>
  <span class="vc-price-display">{{ bossardFormattedAmount }}</span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getBossardFormattedNumber } from "@/core/utilities/innovadis";

interface IProps {
  amount: number;
  currencySymbol?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  currencySymbol: "Є",
});

const { t } = useI18n();

const bossardFormattedAmount = computed(() => {
  return props.amount
    ? `${props.currencySymbol}${getBossardFormattedNumber(props.amount)}`
    : t("ui_kit.labels.not_available");
});
</script>
